var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('h1',[_vm._v(_vm._s(_vm.$t("ABOUT_APPDB")))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('ABOUT_APPDB_DESC'))}}),_c('template',{slot:"sidebar"},[(_vm.BRAND_KEY === 'appdb')?[_c('h2',[_vm._v(_vm._s(_vm.$t("STAY TUNED")))]),_c('html-with-links',{attrs:{"tag":"p","html":_vm.$t('APPDB_SOCIAL', {
            twitterLink: 'https://twitter.com/appdb_official',
            telegramLink: 'https://t.me/appdb_telegram',
            redditLink: 'https://www.reddit.com/r/appdb',
            storyLink: '/info/empire-strikes-back',
          })}})]:_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }